
import { defineComponent, PropType } from 'vue'
import { ElForm } from 'element-plus'
import { MESSAGE_TYPE_CONFIRM, MESSAGE_TYPE_TOAST, addMessageQueue } from '@/plugins/messageQueue'
import Message from '@/services/message'
import { CreateRequest } from '@/requests/judgeDiscussion'
import JrButton from '@/components/jr-parts/JrButton.vue'
import { ProximityJudgeDiscussion } from '@/api'
import MessageService from '@/services/message'
import { MessageTypes } from '@/constants/messageTypes'
import { P_JD_DONE } from '@/constants/statuses'
import { useRouter, RouteLocationRaw } from 'vue-router'

export default defineComponent({
  name: 'JudgeDiscussionSend',
  components: {
    JrButton,
  },
  props: {
    proximityJudgeDiscussion: {
      type: Object as PropType<ProximityJudgeDiscussion>,
      required: true,
    },
    formRef: {
      type: Object as PropType<InstanceType<typeof ElForm>>,
      required: false,
      default: null,
    },
    // 近接工事詳細ID
    proximityId: {
      type: Number,
      required: true,
    },
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()
    // 決定
    const determination = () => {
      if (!props.formRef) {
        return
      }

      props.formRef.validate(async (valid) => {
        if (!valid) {
          return false
        } else {
          const judgeForms: ProximityJudgeDiscussion = {
            judge_discussion_status: props.proximityJudgeDiscussion.judge_discussion_status,
            is_judge_discussion_prior_discussion_unneeded:
              props.proximityJudgeDiscussion.is_judge_discussion_prior_discussion_unneeded,
            is_judge_discussion_witness_unneeded: props.proximityJudgeDiscussion.is_judge_discussion_witness_unneeded,
            judge_discussion_remark: props.proximityJudgeDiscussion.judge_discussion_remark
              ? props.proximityJudgeDiscussion.judge_discussion_remark
              : null,
          }

          // 協議要否によって変数値を設定
          let confirmMessage: string // 確認ダイアログに出力するメッセージ
          let sendUrl: RouteLocationRaw // ステータス更新後の遷移先のURL
          // 協議必要の場合
          if (P_JD_DONE === judgeForms.judge_discussion_status) {
            const NOT_NECESSARY_IN_CHECKBOX = true
            const NECESSARY_IN_CHECKBOX = false
            if (judgeForms.is_judge_discussion_prior_discussion_unneeded === NECESSARY_IN_CHECKBOX) {
              // 事前協議必要の場合
              // 事前協議日程調整ページへ遷移
              confirmMessage = Message.codes.SEND_JUDGE_NECESSARY_DISCUSSION
              sendUrl = {
                name: 'ScheduleMessageSend',
                params: {
                  request_header_id: props.requestHeaderId,
                  message_type: MessageTypes.P_PD_ADJUST_DATE,
                },
              }
            } else if (judgeForms.is_judge_discussion_prior_discussion_unneeded === NOT_NECESSARY_IN_CHECKBOX) {
              // 事前協議不要の場合
              if (judgeForms.is_judge_discussion_witness_unneeded === NECESSARY_IN_CHECKBOX) {
                // 事前協議：不要、現地立会：要  => 現地立会日程調整ページへ遷移
                confirmMessage = Message.codes.CONFIRM_WITNESS_SCHEDULE
                sendUrl = {
                  name: 'JrScheduleMessageSend',
                  params: {
                    request_header_id: props.requestHeaderId,
                    message_type: MessageTypes.P_WS_JR_ADJUST_DATE,
                  },
                }
              } else if (judgeForms.is_judge_discussion_witness_unneeded === NOT_NECESSARY_IN_CHECKBOX) {
                // 事前協議：不要、現地立会：不要  => 協議書作成ページへ遷移
                confirmMessage = Message.codes.CONFIRM_DISCUSSION_DOCUMENT
                sendUrl = {
                  name: 'NormalMessageSend',
                  params: {
                    request_header_id: props.requestHeaderId,
                    message_type: MessageTypes.P_DD_REQUEST,
                    action: 'send',
                  },
                }
              }
            }
          } else {
            // 協議不要の場合
            judgeForms.is_judge_discussion_prior_discussion_unneeded = null
            judgeForms.is_judge_discussion_witness_unneeded = null
            confirmMessage = Message.codes.SEND_JUDGE_UNNECESSARY_DISCUSSION
            sendUrl = {
              name: 'NormalMessageSend',
              params: {
                request_header_id: props.requestHeaderId,
                message_type: MessageTypes.P_JD_UNNECESSARY_NOTICE,
                action: 'send',
              },
            }
          }

          // 確認ダイアログ表示
          addMessageQueue(MESSAGE_TYPE_CONFIRM, MessageService.codes.CONFIRM_SAVE, async () => {
            // OKなら送信する
            // requestの作成
            const request = new CreateRequest(props.proximityId, judgeForms)

            // API実行
            await request.exec()

            // API成功
            if (request.success) {
              addMessageQueue(
                MESSAGE_TYPE_TOAST,
                MessageService.bind(MessageService.codes.SEND_COMPLETE, { target: '協議要否判断' })
              )
              // トーストを確認する時間を作る
              setTimeout(() => {
                // 確認ダイアログ表示
                addMessageQueue(
                  MESSAGE_TYPE_CONFIRM,
                  confirmMessage,
                  () => {
                    // OKなら各画面へ遷移する
                    router.push(sendUrl)
                  },
                  () => {
                    // キャンセルなら詳細画面に遷移する
                    router.push({
                      name: 'ProximityDetail',
                      params: {
                        request_header_id: props.requestHeaderId,
                      },
                    })
                  }
                )
              }, 1500)
            }
          })
        }
      })
    }

    return {
      determination,
    }
  },
})
